// extracted by mini-css-extract-plugin
export default {"selected-dropdown-item":"selectedItem_selected-dropdown-item__yJ5c8"};